import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';

import aboutImg1 from '../../assets/img/about/about-4-1.jpg';
import aboutImg2 from '../../assets/img/about/about-4-2.jpg';
import shapeImg1 from '../../assets/img/about/shape-4-2.png';
import shapeImg2 from '../../assets/img/about/shape-4-1.png';

const About = () => {
  return (
    <div
      id="it-about"
      className="it-about-2-area it-about-style-2 p-relative pt-120 pb-120"
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 order-1 order-lg-0 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-4-left p-relative">
              <div className="it-about-4-thumb-1">
                <img src={aboutImg1} alt="" />
              </div>
              <div className="it-about-4-thumb-2">
                <img src={aboutImg2} alt="" />
              </div>
              <div className="it-about-4-shape-1 d-none d-lg-block">
                <img src={shapeImg1} alt="" />
              </div>
              <div className="it-about-4-shape-2 d-none d-lg-block">
                <img src={shapeImg2} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 order-0 order-lg-1 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-2-right">
              <div className="it-about-2-content">
                <SectionTitle
                  itemClass="it-about-2-title-box mb-20"
                  subTitleClass="it-section-subtitle green"
                  subTitle="About us"
                  titleClass="it-section-title"
                  title="Modern Caring Mental Health & BehavioralTo Sciences."
                />
                <span>
                  There are emits consectetur notted aetinciduns pisicing elit
                  sed a eiusmode tempor incididunt ut labore et dolore magna
                  aliqua lonmea...
                </span>
                <p className="mb-30">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip
                </p>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="it-about-2-icon-box style-1">
                      <span>
                        <i className="flaticon-counseling"></i>
                      </span>
                      <h5>Online Counseling</h5>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="it-about-2-icon-box style-2">
                      <span>
                        <i className="flaticon-artificial-intelligence"></i>
                      </span>
                      <h5>Group Therapy</h5>
                    </div>
                  </div>
                </div>
                <div className="it-about-2-tel-wrap mt-30 flex-wrap d-sm-flex align-items-center">
                  <Link
                    className="it-btn-theme grey-bg mr-55"
                    to="/service-details"
                  >
                    <Button btnText="Our Counseling" />
                  </Link>
                  <div className="it-about-2-tel-box d-flex align-items-center">
                    <div className="it-about-2-tel-icon">
                      <span>
                        <i className="flaticon-message"></i>
                      </span>
                    </div>
                    <div className="it-about-2-tel-text">
                      <span>Emergency</span>
                      <a className="hover-anim" href="tel:99012356987">
                        (+99) 012356987
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
